import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Phone } from 'lucide-react';
import { Button } from './ui/Button';
import { locations, GLOBAL_PHONE } from '../data/locations';
import { programs } from '../data/programs';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLocationsDropdownOpen, setIsLocationsDropdownOpen] = useState(false);
  const [isProgramsDropdownOpen, setIsProgramsDropdownOpen] = useState(false);
  const navItems = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'Programs',
    path: '/programs',
    hasDropdown: true,
    dropdownType: 'programs'
  }, {
    label: 'Locations',
    path: '/locations',
    hasDropdown: true,
    dropdownType: 'locations'
  }, {
    label: 'Instructors',
    path: '/instructors'
  }, {
    label: 'Merch',
    path: '/merch'
  }, {
    label: 'Forms & Videos',
    path: '/forms-videos'
  }, {
    label: 'FAQs',
    path: '/faqs'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-100 shadow-sm" data-id="element-237">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-238">
        <div className="flex justify-center items-center h-20" data-id="element-239">
          {/* Logo */}
          <div className="absolute left-4 sm:left-6 lg:left-8" data-id="element-240">
            <Link to="/" data-id="element-241">
              <img src="https://cdn.magicpatterns.com/uploads/5Qiz8EjgR1snEvxNqavy5Z/logo_copy.png" alt="Che Ko Martial Arts" className="h-[72px] w-auto" data-id="element-242" />
            </Link>
          </div>

          {/* Desktop Navigation - Centered */}
          <nav className="hidden xl:flex space-x-6 items-center" data-id="element-243">
            {navItems.map(item => item.hasDropdown ? <div key={item.path} className="relative" onMouseEnter={() => {
            if (item.dropdownType === 'locations') {
              setIsLocationsDropdownOpen(true);
            } else if (item.dropdownType === 'programs') {
              setIsProgramsDropdownOpen(true);
            }
          }} onMouseLeave={() => {
            if (item.dropdownType === 'locations') {
              setIsLocationsDropdownOpen(false);
            } else if (item.dropdownType === 'programs') {
              setIsProgramsDropdownOpen(false);
            }
          }} data-id="element-244">
                  <Link to={item.path} className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors flex items-center py-2" data-id="element-245">
                    {item.label}
                    <ChevronDown className="ml-1 h-4 w-4" data-id="element-246" />
                  </Link>

                  {/* Programs Dropdown */}
                  {item.dropdownType === 'programs' && isProgramsDropdownOpen && <div className="absolute top-full left-0 pt-2" data-id="element-247">
                        <div className="w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-2" data-id="element-248">
                          {programs.map(program => <Link key={program.id} to={`/programs/${program.id}`} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-249">
                              {program.name}
                            </Link>)}
                          <div className="border-t border-slate-200 my-2" data-id="element-250"></div>
                          <Link to="/black-belt-club" className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-251">
                            Black Belt Club
                          </Link>
                        </div>
                      </div>}

                  {/* Locations Dropdown */}
                  {item.dropdownType === 'locations' && isLocationsDropdownOpen && <div className="absolute top-full left-0 pt-2" data-id="element-252">
                        <div className="w-64 bg-white rounded-lg shadow-lg border border-slate-200 py-2" data-id="element-253">
                          {locations.map(location => <Link key={location.id} to={`/locations/${location.id}`} className="block px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-[#1a2332] transition-colors" data-id="element-254">
                              {location.name}
                            </Link>)}
                        </div>
                      </div>}
                </div> : <Link key={item.path} to={item.path} className="text-sm font-medium text-slate-600 hover:text-[#1a2332] transition-colors" data-id="element-255">
                  {item.label}
                </Link>)}
          </nav>

          {/* Phone & CTA - Right Side */}
          <div className="hidden xl:flex items-center gap-4 absolute right-4 sm:right-6 lg:right-8" data-id="element-256">
            <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="flex items-center text-sm font-medium text-slate-600 hover:text-[#dc2626] transition-colors" data-id="element-257">
              <Phone className="h-4 w-4 mr-2" data-id="element-258" />
              {GLOBAL_PHONE}
            </a>
            <Button variant="primary" size="sm" data-id="element-259">
              Get 2 Weeks Free
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="absolute right-4 sm:right-6 flex items-center xl:hidden" data-id="element-260">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-slate-400 hover:text-slate-500 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#1a2332]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} data-id="element-261">
              <span className="sr-only" data-id="element-262">Open main menu</span>
              {isMobileMenuOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-263" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-264" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="xl:hidden bg-white border-t border-slate-100" data-id="element-265">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-266">
            {/* Phone Number in Mobile Menu */}
            <a href={`tel:${GLOBAL_PHONE.replace(/\D/g, '')}`} className="flex items-center px-3 py-2 rounded-md text-base font-medium text-[#dc2626] hover:bg-slate-50" data-id="element-267">
              <Phone className="h-5 w-5 mr-2" data-id="element-268" />
              {GLOBAL_PHONE}
            </a>

            {navItems.map(item => item.hasDropdown ? <div key={item.path} data-id="element-269">
                  <Link to={item.path} className="block px-3 py-2 rounded-md text-base font-medium text-slate-700 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-270">
                    {item.label}
                  </Link>
                  <div className="pl-6 space-y-1" data-id="element-271">
                    {item.dropdownType === 'programs' && <>
                        {programs.map(program => <Link key={program.id} to={`/programs/${program.id}`} className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-272">
                            {program.name}
                          </Link>)}
                        <Link to="/black-belt-club" className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-273">
                          Black Belt Club
                        </Link>
                      </>}
                    {item.dropdownType === 'locations' && locations.map(location => <Link key={location.id} to={`/locations/${location.id}`} className="block px-3 py-2 rounded-md text-sm text-slate-600 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-274">
                          {location.name}
                        </Link>)}
                  </div>
                </div> : <Link key={item.path} to={item.path} className="block px-3 py-2 rounded-md text-base font-medium text-slate-700 hover:text-[#1a2332] hover:bg-slate-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-275">
                  {item.label}
                </Link>)}
            <div className="mt-4 px-3" data-id="element-276">
              <Button variant="primary" className="w-full justify-center" data-id="element-277">
                Get 2 Weeks Free
              </Button>
            </div>
          </div>
        </div>}
    </header>;
}